// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crown-config{z-index:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;height:1.85rem;border-radius:5px}.crown-config,.crown-config:after{background-color:#3397e1;position:absolute}.crown-config:after{content:\"\";width:1.25rem;height:1.25rem;top:.8rem;left:.3rem;z-index:-1;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:1px}", ""]);
// Exports
module.exports = exports;
